<ng-container *transloco="let t">
  <!-- WITH PRODUCT -->

  @if (product && !category && !brand) {
    @if (!showShortText || (showShortText && product.metadata.shortText)) {
      <nav
        [class.rtl]="isRtl$ | async"
        [class.widescreen]="!(lessThan$ | async)?.md && !showShortText"
        class="collection-title collection-mode">
        @if (product.brand) {
          <h1>{{ product.brand }}</h1>
        }
        @if (product.model) {
          <h1>{{ product.model }}</h1>
        }
      </nav>

      @if (showShortText && product.metadata.shortText) {
        <nav
          [class.rtl]="isRtl$ | async"
          [class.widescreen]="!(lessThan$ | async)?.md && !showShortText"
          class="collection-title collection-mode">
          <p class="short-text">{{ product.metadata.shortText }}</p>
        </nav>
      }
    }
  }

  <!-- NO PRODUCT -->
  @if ((category || brand) && !showShortText) {
    <nav
      [class.rtl]="isRtl$ | async"
      [class.widescreen]="!(lessThan$ | async)?.md"
      class="collection-title collection-mode">
      @if (brand) {
        <h1>{{ brand }}</h1>
      }
      @if (category) {
        <h1>
          {{
            t(
              'category_' + (capitalizeCategory(category)?.toLowerCase() || '') + '_title'
            )
          }}
        </h1>
      }
      @if (model) {
        <h1>{{ model }}</h1>
      }
    </nav>
  }
</ng-container>
